<template>
  <div />
</template>

<script>
// eslint-disable-next-line vue/multi-word-component-names
export default { name: 'Home' }
</script>
